module.exports = __webpack_public_path__ + "static/Litschi-8ec55da0a906c7e386e38c9c707e14c2.png";